export default __webpack_public_path__ + "static/media/pulse.da3c0107.png";